import type { ISpecialityDescription } from './types'

export const AVAILABLE_SPECIALITIES: string[] = [
  'servicoAssistenteSocial',
  'servicoMedico',
  'servicoEnfermagem',
  'servicoPsicologia',
  'servicoNutricao',
  'servicoDentista',
  'servicoFisioterapeuta',
  'servicoFonoaudiologo',
  'servicoPsicologiaViva',
]

export const SPECIALITIES_DESCRIPTION_AMIL: ISpecialityDescription = {
  ASSISTENTE_SOCIAL: {
    title: 'Assistentes sociais',
    description: 'Para acolher e encaminhar ao especialista adequado.',
  },
  DENTISTA: {
    title: 'Dentistas',
    description:
      'Para garantir a saúde dos dentes, da gengiva e da higiene bucal.',
  },
  ENFERMEIRO: {
    title: 'Enfermeiros',
    description: 'Para orientar e acompanhar o tratamento do paciente.',
  },
  FISIOTERAPEUTA: {
    title: 'Fisioterapeutas',
    description: 'Para atuar na reabilitação física do paciente',
  },
  FONOAUDIOLOGO: {
    title: 'Fonoaudiologos',
    description: 'Para ajudar a desenvolver a comunicação oral e escrita.',
  },
  MEDICO: {
    title: 'Médicos',
    description: 'Para cuidar da saúde por completo com clínicos gerais.',
  },
  NUTRICIONISTA: {
    title: 'Nutricionistas',
    description: 'Para orientar sobre hábitos e alimentação saudáveis.',
  },
  PSICOLOGO: {
    title: 'Psicólogos',
    description: 'Para cuidar da saúde da mente e das emoções.',
  },
  // PSICOLOGO_VIVA: '',
}

export const SPECIALITIES_DESCRIPTION: ISpecialityDescription = {
  ASSISTENTE_SOCIAL: {
    title: 'Assistentes sociais',
    description: 'Para acolher e encaminhar ao especialista adequado.',
  },
  DENTISTA: {
    title: 'Dentistas',
    description:
      'Para garantir a saúde dos dentes, da gengiva e da higiene bucal.',
  },
  ENFERMEIRO: {
    title: 'Enfermeiros',
    description: 'Para orientar e acompanhar o tratamento do paciente.',
  },
  FISIOTERAPEUTA: {
    title: 'Fisioterapeutas',
    description: 'Para atuar na reabilitação física do paciente',
  },
  FONOAUDIOLOGO: {
    title: 'Fonoaudiologos',
    description: 'Para ajudar a desenvolver a comunicação oral e escrita.',
  },
  MEDICO: {
    title: 'Médicos',
    description:
      'Para cuidar da saúde por completo com clínicos gerais e especialistas.',
  },
  NUTRICIONISTA: {
    title: 'Nutricionistas',
    description: 'Para orientar sobre hábitos e alimentação saudáveis.',
  },
  PSICOLOGO: {
    title: 'Psicólogos',
    description: 'Para cuidar da saúde da mente e das emoções.',
  },
  // PSICOLOGO_VIVA: '',
}
